import { Field, Input, Textarea } from "@sagot/ui";
import type { ReactNode } from "react";

interface CountedProps {
  label: string;
  hint?: ReactNode;
  value: string;
  max: number;
  disabled: boolean;
  placeholder?: string;
  className?: string;
  onChange: (value: string) => void;
}

function Counter({ hint, length, max }: { hint?: ReactNode; length: number; max: number }) {
  return (
    <>
      {hint ? <>{hint} </> : null}
      <span className="font-mono tabular-nums">{`${String(length)}/${String(max)}`}</span>
    </>
  );
}

/** A text area with a character counter that never lets the text pass the limit. */
export function CountedTextarea({ label, hint, value, max, disabled, placeholder, className, onChange, rows = 3 }: CountedProps & { rows?: number }) {
  return (
    <Field label={label} hint={<Counter hint={hint} length={value.length} max={max} />} className={className}>
      <Textarea rows={rows} maxLength={max} disabled={disabled} placeholder={placeholder} value={value} onChange={(e) => { onChange(e.target.value); }} />
    </Field>
  );
}

/** A single-line field with a character counter. */
export function CountedInput({ label, hint, value, max, disabled, placeholder, className, onChange }: CountedProps) {
  return (
    <Field label={label} hint={<Counter hint={hint} length={value.length} max={max} />} className={className}>
      <Input maxLength={max} disabled={disabled} placeholder={placeholder} value={value} onChange={(e) => { onChange(e.target.value); }} />
    </Field>
  );
}
